const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE,
  authDomain: "coral-field-215519.firebaseapp.com",
  databaseURL: "https://coral-field-215519.firebaseio.com/",
  credential: null,
  storageBucket: "coral-field-215519.appspot.com",
  projectId:"coral-field-215519",
  messagingSenderId: "290410050075",
    appId: "1:290410050075:web:da041f0fe24ca34d4cbebe",
    measurementId: "G-0N5NQG35ZD"
};

export { firebaseConfig };
